/**
 * Imágenes del producto (DPS 39 · The No-Prep Chess Club Megapack).
 *
 * HERO_MOCKUP: mockup principal (carpeta `mockup` en Drive). Mientras sea
 * null, el hero y el pricing muestran un abanico de páginas reales del
 * Volume 1 (Gamma).
 * BONUS_COVERS: mockups de los 5 bonus. null = card de portada diseñada.
 */
export const HERO_MOCKUP: string | null =
  'https://cdn.magicpatterns.com/uploads/hGTCeZBhMMtCoqL3cAEjaj/Photorealistic-product-mockup-warm-life.png'

export const BONUS_COVERS: Record<string, string | null> = {
  '01': 'https://cdn.magicpatterns.com/uploads/2gGVVT3Q2K8KKigGcfcoCT/DPS39_-_Bono_1_-_The_Coachs_Rules__Questions_Cheat-Sheet.png',
  '02': 'https://cdn.magicpatterns.com/uploads/uqqWED8VbA95DNVe3D9XGN/DPS39_-_Bono_2_-_The_No-Equipment_Club_Kit.png',
  '03': 'https://cdn.magicpatterns.com/uploads/4nySw8GobAvFTv543LrquR/DPS39_-_Bono_3_-_The_Parent_Take-Home_Pack.png',
  '04': 'https://cdn.magicpatterns.com/uploads/4Dk37b8TLwLHSTzQ6f3m7K/DPS39_-_Bono_4_-_The_Lesson-in-a-Pinch_Cards.png',
  '05': 'https://cdn.magicpatterns.com/uploads/jjXhiyKJB7PDot8W97aCvV/DPS39_-_Bono_5_-_The_Start_Here_Club_Launch_Map.png',
}

/** Páginas reales del Volume 1 en Gamma (CDN público). */
export const VOLUME_PAGES = {
  cover:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/8C2NhoYdwaf_xFuQ.jpg',
  session:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/gYQNXunBFJzkHnI7.jpg',
  worksheet:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/N4CAnmVESdKcTAYt.jpg',
  soNoSoYes:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/FveE8LegAHIxi0Q8.jpg',
  bigClub:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/Yzjg_sIt6-KBpxm2.jpg',
  fieldCard:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/eT4sdunNDn8MwKS1.jpg',
}
